/* ──────────────────────────────────────────────
   src/hooks/useCentros.ts
   Hook para gestión de centros usando factory CRUD
   ────────────────────────────────────────────── */
import { useCrudResource } from './factories/useCrudResource';
import type { Centro } from '../types/entities';

// Re-exportar tipo para compatibilidad
export type { Centro };

export function useCentros() {
  return useCrudResource<Centro>({
    queryKey: ['centros'],
    endpoint: '/centros',
  });
}
